import React, { FunctionComponent } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import styles from './ProgramDetail.module.scss';
import Text from 'common/components/Text/Text';
import { useGetBackofficeProgramQuery, useDeleteProgramMutation } from 'services/exploreApi';
import Loader from 'common/components/Loader/Loader';

const ProgramDetail: FunctionComponent = () => {
  const { id } = useParams<{ id: string }>();
  const { data: program, isLoading } = useGetBackofficeProgramQuery(parseInt(id || ''));
  const [deleteProgram] = useDeleteProgramMutation();
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (program) {
      await deleteProgram(program.data.id);
      navigate('/backoffice/programs');
    }
  };
  if (isLoading) return <Loader />;

  return (
    <div className={styles.container}>
      <div className={styles.firstWrap}>
        <Text size={40} weight={700}>
          {program?.data.name}
        </Text>
        <div className={styles.buttonsWrap}>
          <Link className={`${styles.exitButton} btn`} to="edit">
            Edit
          </Link>
          <Link className={`${styles.exitButton} btn ${styles.outline}`} to="edit/photos">
            Add/Edit Photos
          </Link>
          <button
            className={`${styles.exitButton} btn ${styles.outlineDanger}`}
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
      <div className={styles.options}>
        <div className={styles.element}>
          <label htmlFor="school">School</label>
          <Text size={18} weight={400}>
            {program?.data.school.name}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="web_page">Web Page</label>
          <Text size={18} weight={400}>
            {program?.data.web_page}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="overview">Overview</label>
          <Text size={18} weight={400}>
            {program?.data.overview}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="average_age">Average Age</label>
          <Text size={18} weight={400}>
            {program?.data.average_age}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="international_student_percentage">International Student Percentage</label>
          <Text size={18} weight={400}>
            {program?.data.international_student_percentage}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="average_salary">Average Salary</label>
          <Text size={18} weight={400}>
            {program?.data.average_salary}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="salary_increase">Salary Increase</label>
          <Text size={18} weight={400}>
            {program?.data.salary_increase}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="offer_acceptance_percentage">Offer Acceptance Percentage</label>
          <Text size={18} weight={400}>
            {program?.data.offer_acceptance_percentage}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="work_experience_min">Minimum Work Experience</label>
          <Text size={18} weight={400}>
            {program?.data.work_experience_min}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="work_experience_avg">Average Work Experience</label>
          <Text size={18} weight={400}>
            {program?.data.work_experience_avg}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="work_experience_max">Maximum Work Experience</label>
          <Text size={18} weight={400}>
            {program?.data.work_experience_max}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="relevant_degree_require">Relevant Degree Required</label>
          <Text size={18} weight={400}>
            {program?.data.relevant_degree_require}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="why_choose_this_program">Why Choose This Program</label>
          <Text size={18} weight={400}>
            {program?.data.why_choose_this_program}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="teaching_and_modules">Teaching and Modules</label>
          <Text size={18} weight={400}>
            {program?.data.teaching_and_modules}
          </Text>
        </div>
        <div className={styles.element}>
          <label htmlFor="career_information">Career Information</label>
          <Text size={18} weight={400}>
            {program?.data.career_information}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="language">Language</label>
          <Text size={18} weight={400}>
            {program?.data.language}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="employability">Employability</label>
          <Text size={18} weight={400}>
            {program?.data.employability}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="priority">Priority</label>
          <Text size={18} weight={400}>
            {program?.data.priority}
          </Text>
        </div>
        {/* 
        <div className={styles.element}>
          <label htmlFor="tuition_min">Minimum Tuition</label>
          <Text size={18} weight={400}>
            {program?.data.tuition_min}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="tuition_max">Maximum Tuition</label>
          <Text size={18} weight={400}>
            {program?.data.tuition_max}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="intake_date_min">Minimum Intake Date</label>
          <Text size={18} weight={400}>
            {program?.data.intake_date_min}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="intake_date_max">Maximum Intake Date</label>
          <Text size={18} weight={400}>
            {program?.data.intake_date_max}
          </Text>
        </div> */}

        <div className={styles.element}>
          <label htmlFor="period_type">Period Type</label>
          <Text size={18} weight={400}>
            {program?.data.period_type}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="employability_time">Employability Time</label>
          <Text size={18} weight={400}>
            {program?.data.employability_time}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="employability_score">Employability Score</label>
          <Text size={18} weight={400}>
            {program?.data.employability_score}
          </Text>
        </div>

        {/* <div className={styles.element}>
          <label htmlFor="assessment_text">Assessment Text</label>
          <Text size={18} weight={400}>
            {program?.data.assessment_text}
          </Text>
        </div> */}

        <div className={styles.element}>
          <label htmlFor="description">Description</label>
          <Text size={18} weight={400}>
            {program?.data.description}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="men_women_percentage">Men and Women Percentage</label>
          <Text size={18} weight={400}>
            {program?.data.men_women_percentage}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="fee_cost_description">Fee Cost Description</label>
          <Text size={18} weight={400}>
            {program?.data.fee_cost_description}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="application_fee">Application Fee</label>
          <Text size={18} weight={400}>
            {program?.data.application_fee}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="application_fee_currency">Application Fee Currency</label>
          <Text size={18} weight={400}>
            {program?.data.application_fee_currency}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="deposit">Deposit</label>
          <Text size={18} weight={400}>
            {program?.data.deposit}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="deposit_currency">Deposit Currency</label>
          <Text size={18} weight={400}>
            {program?.data.deposit_currency}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="is_visible">Is Visible</label>
          <Text size={18} weight={400}>
            {program?.data.is_visible}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="requirement_document_description">Requirement Document Description</label>
          <Text size={18} weight={400}>
            {program?.data.requirement_document_description}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="working_after_months">Working After Months</label>
          <Text size={18} weight={400}>
            {program?.data.working_after_months}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="working_after_percentage">Working After Percentage</label>
          <Text size={18} weight={400}>
            {program?.data.working_after_percentage}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="period_type">Period Type</label>
          <Text size={18} weight={400}>
            {program?.data.period_type}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="degree_type">Degree Type</label>
          <Text size={18} weight={400}>
            {program?.data.degree_type}
          </Text>
        </div>

        <div className={styles.element}>
          <label htmlFor="prefix">Prefix</label>
          <Text size={18} weight={400}>
            {program?.data.prefix}
          </Text>
        </div>

        <div className={styles.element}>
          <Text size={20} weight={600}>
            Study Options
          </Text>
        </div>

        {program?.data.study_options.map((studyOption, index) => (
          <div key={index} className={styles.options}>
            <Text size={18} weight={600}>
              Study Option {index + 1}
            </Text>

            <div className={styles.element}>
              <label htmlFor="study_option_city">Location</label>
              <Text size={18} weight={400}>
                {studyOption.city.name}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_delivery">Delivery</label>
              <Text size={18} weight={400}>
                {studyOption.delivery}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_schedule">Schedule</label>
              <Text size={18} weight={400}>
                {studyOption.schedule}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_duration_in_months">Duration in months</label>
              <Text size={18} weight={400}>
                {studyOption.duration_in_months}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_status">Status</label>
              <Text size={18} weight={400}>
                {studyOption.status}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_external_id">External id</label>
              <Text size={18} weight={400}>
                {studyOption.external_id}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_tuition_fee.currency">External id</label>
              <Text size={18} weight={400}>
                {studyOption.tuition_fee.currency}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_tuition_fee_amount_domestic">Amount Domestic</label>
              <Text size={18} weight={400}>
                {studyOption.tuition_fee.amount_domestic}
              </Text>
            </div>

            <div className={styles.element}>
              <label htmlFor="study_option_tuition_fee_amount_international">
                Amount International
              </label>
              <Text size={18} weight={400}>
                {studyOption.tuition_fee.amount_international}
              </Text>
            </div>

            <Text size={20} weight={600}>
              Intake Dates
            </Text>
            {studyOption.intake_dates?.map((intakeDate, idx) => (
              <div key={idx} className={styles.options}>
                <Text size={18} weight={400}>
                  Intake Date {idx + 1}
                </Text>

                <div className={styles.element}>
                  <label htmlFor="intake_date">Intake Date</label>
                  <Text size={18} weight={400}>
                    {String(intakeDate.date)}
                  </Text>
                </div>
                {intakeDate.deadline_dates?.map((deadlineDate, i) => (
                  <div key={i} className={styles.options}>
                    <Text size={18} weight={400}>
                      Deadline Date {i + 1}
                    </Text>
                    <div className={styles.element}>
                      <label htmlFor="deadline_date">Date</label>
                      <Text size={18} weight={400}>
                        {String(deadlineDate.date)}
                      </Text>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramDetail;
